import { Link } from 'react-router'
import { trpc } from '@/config/trpc'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'
import { Checkbox } from '@/components/ui/shadcn/checkbox'

export function AccountNotificationsPage() {
  const { data: settings } = trpc.user.getNotificationSettings.useQuery()
  const utils = trpc.useUtils()
  const { mutate: updateSettings } = trpc.user.updateNotificationSettings.useMutation({
    onMutate: async (newSettings) => {
      await utils.user.getNotificationSettings.cancel()
      const previous = utils.user.getNotificationSettings.getData()
      utils.user.getNotificationSettings.setData(undefined, newSettings)
      return { previous }
    },
    onError: (_err, _newSettings, context) => {
      if (context?.previous) {
        utils.user.getNotificationSettings.setData(undefined, context.previous)
      }
    },
  })

  if (!settings) return null

  const toggle = (
    key: 'scheduledPostReminder' | 'postPublished' | 'postFailed',
    checked: boolean,
  ) => {
    updateSettings({ ...settings, [key]: checked })
  }

  const notifications = [
    {
      key: 'scheduledPostReminder' as const,
      label: 'Scheduled post reminders',
      description: 'Get an email 1 hour before your scheduled post goes live.',
    },
    {
      key: 'postPublished' as const,
      label: 'Post published confirmations',
      description: 'Get an email when your scheduled post has been published.',
    },
    {
      key: 'postFailed' as const,
      label: 'Post failure alerts',
      description: "Get an email when a scheduled post couldn't be published.",
    },
  ]

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl sm:text-2xl">Notifications</CardTitle>
        <CardDescription>Choose which email notifications you receive</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {notifications.map((n) => (
            <div key={n.key} className="space-y-1">
              <div className="flex items-center gap-3">
                <Checkbox
                  id={n.key}
                  checked={settings[n.key]}
                  onCheckedChange={(checked) => toggle(n.key, checked === true)}
                />
                <label htmlFor={n.key} className="text-foreground text-sm font-medium">
                  {n.label}
                </label>
              </div>
              <p className="text-muted-foreground ml-7 text-sm">{n.description}</p>
            </div>
          ))}
        </div>
        <p className="text-muted-foreground mt-6 text-sm">
          Automated post suggestion emails are managed per row from your{' '}
          <Link to="/automations" className="text-primary hover:underline">
            Automations
          </Link>{' '}
          schedule.
        </p>
      </CardContent>
    </Card>
  )
}
